import RoleHome from '../../components/RoleHome/RoleHome';
export default function AdminHome() {
  return <RoleHome role="admin" />;
}